// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoToolbar_container__kmdXX","close":"InfoToolbar_close__uOJlC"};